import { render, staticRenderFns } from "./AmexLogo.vue?vue&type=template&id=4dbf7678&scoped=true&"
var script = {}
import style0 from "./AmexLogo.vue?vue&type=style&index=0&id=4dbf7678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf7678",
  null
  
)

export default component.exports